import React, { FC } from 'react';
import { AssigneeField, UserId } from 'components/organisms/tasks/fields';
import { to_query } from 'components/pages/filter-transformer';
import { ofNullable } from 'core/maybe';
import { TaskField } from 'stores/fields';
import { constructTaskFilterUrl } from '../../../utils/construct-task-filter-url';
import { useSortByCountGroupedArray } from '../avatar-count-list';
import { restrictToUser } from '../restrict-to-user';
import { TasksCount } from '../tasks-count';
import { useTasksAtRisk, getTasksAtRiskFilter } from './use-tasks-at-risk';

export const Count: FC<{
  projectId: number;
  taskFields: Record<string, TaskField>;
}> = ({ projectId, taskFields }) => {
  const data = useTasksAtRisk(projectId);
  const sortedList = useSortByCountGroupedArray(data);
  const filter = getTasksAtRiskFilter(taskFields);
  const assignee = ofNullable(taskFields.assignee as AssigneeField);
  const forUser = restrictToUser(assignee)(filter);
  const groups = sortedList.map((value) => ({
    user: value.avatar,
    count: value.count,
    url: constructTaskFilterUrl(
      projectId,
      to_query(forUser(UserId(value.avatar.userId))),
    ),
  }));

  return (
    <TasksCount
      color="var(--red-60)"
      count={data.length}
      groups={groups}
      url={constructTaskFilterUrl(projectId, to_query(filter))}
    />
  );
};
